// ** React Imports
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
// ** Reactstrap Imports
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
  Spinner,
  UncontrolledTooltip
} from "reactstrap"
// ** Third Party Components
import Select from "react-select"
import { Eye, MapPin, User } from "react-feather"
// ** Custom Components
import Avatar from "@components/avatar"
// ** Utils and Libs
import { convertNameToColor, dateISO } from "@lib/util"
import { getAllFromController } from "@lib/api"

const RecentlyAddedPersons = () => {
  const personsToDisplayChoices = [
    { value: 20, label: "20" },
    { value: 35, label: "35" },
    { value: 50, label: "50" }
  ]

  // ** Hooks
  const [persons, setPersons] = useState()
  const [numberOfPersons, setNumberOfPersons] = useState(personsToDisplayChoices[0].value)

  useEffect(() => {
    async function fetchData() {
      setPersons(null) // not pretty but display spinner
      const persons = await getAllFromController(`Persons/RecentlyAdded?limit=${numberOfPersons}`)
      setPersons(persons)
    }
    fetchData()
  }, [numberOfPersons])

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h4">Recently added persons</CardTitle>
        <div className="d-flex align-items-center">
          Show the last
          <Select
            className="react-select mx-50"
            classNamePrefix="select"
            isSearchable={false}
            defaultValue={personsToDisplayChoices[0]}
            options={personsToDisplayChoices}
            isClearable={false}
            onChange={(value) => setNumberOfPersons(value.value)}
          />
          persons
        </div>
      </CardHeader>
      <CardBody>
        <ListGroup className="mt-2">
          {persons ? (
            <>
              {persons.map((person) => (
                <Link to={`/CRM/Visits/${person.personId}`} key={person.personId}>
                  <ListGroupItem key={person.personId}>
                    <Row>
                      <Col className="d-flex align-items-center">
                        <div className="w-25">
                          <div className="text-muted me-3">
                            {dateISO(person.createdOn, true, true)}
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div>
                            <Avatar
                              color={`light-${convertNameToColor(person.name)}`}
                              className="me-3"
                              content={`${person.name} ${person.firstName}`}
                              initials
                            />
                          </div>
                          <div>
                            <div className="fw-bolder text-black">
                              {person.name} {person.firstName}
                            </div>
                            {(person.emails.length > 0 || person.phones.length > 0) && (
                              <div className="text-muted small">
                                {person.emails.length > 0 && person.emails[0]}
                                {person.emails.length > 0 && person.phones.length > 0 && " - "}
                                {person.phones.length > 0 && person.phones[0]}
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <Row>
                          {person.initialEvent && (
                            <>
                              <Col className="d-flex align-items-center">
                                <User size={20} className="me-50" color="lightgray" />
                                <div key={person.initialEvent.collaboratorId}>
                                  <span className="text-muted small">Created by :</span>
                                  <br />
                                  <span className="text-black">
                                    {person.initialEvent.collaborator?.name.trim()}{" "}
                                    {person.initialEvent.collaborator?.firstName.trim()}
                                  </span>
                                </div>
                              </Col>
                              <Col className="d-flex align-items-center">
                                <MapPin size={20} className="me-50" color="lightgray" />
                                <div key={person.initialEvent.showroomId}>
                                  <span className="text-muted small">In :</span>
                                  <br />
                                  <span className="text-black">
                                    {person.initialEvent.showroom?.name}
                                  </span>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </Col>
                      <Col md="1" className="btn">
                        <Eye size={15} id={`eye-icon-${person.personId}`} />
                        <UncontrolledTooltip
                          placement="left"
                          target={`eye-icon-${person.personId}`}
                        >
                          Open person details
                        </UncontrolledTooltip>
                      </Col>
                    </Row>
                  </ListGroupItem>
                </Link>
              ))}
              {persons.length === 0 && (
                <div className="d-flex mx-auto my-3">
                  <b>No persons found</b>
                </div>
              )}
            </>
          ) : (
            <center>
              <Spinner color="primary" />
            </center>
          )}
        </ListGroup>
      </CardBody>
    </Card>
  )
}

export default RecentlyAddedPersons
